import { useContext, useMemo } from 'react';

import { FeaturesContext } from '../providers/FeaturesProvider';

export const useFeatures = () => {
  const { adminFeatures, globalFeatures, isLoading, refetchFeatures, isFetching } = useContext(FeaturesContext);

  return useMemo(() => {
    const combinedFeatures = [...adminFeatures, ...globalFeatures].filter(
      (feature, index, self) => self.indexOf(feature) === index,
    );

    return {
      features: combinedFeatures,
      refetchFeatures,
      isLoading,
      isFetching,
    };
  }, [adminFeatures, globalFeatures, isLoading, refetchFeatures, isFetching]);
};
